export const SETTINGS_META_DATA = {
  CATEGORY: "category",
  GROUP: "group",
  BRAND: "brand",
  NAME: "product-name",
  CONDITION: "condition",
  UNIT: "unit",
};
